import { render, staticRenderFns } from "./agenda-grouped-item.vue?vue&type=template&id=60f66de6&scoped=true&"
import script from "./agenda-grouped-item.vue?vue&type=script&lang=js&"
export * from "./agenda-grouped-item.vue?vue&type=script&lang=js&"
import style0 from "./agenda-grouped-item.vue?vue&type=style&index=0&id=60f66de6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f66de6",
  null
  
)

export default component.exports